import BASE_URL from '../../utils/storage.js';
import { getActiveLanguage } from '../../i18n/languageStore.js';
import StorageService from '../storage/storageService.js';

export const websocketAPI = {
  async createTicket({ signal } = {}) {
    const token = StorageService.getAuthToken();
    if (!token) {
      throw new Error('Authentication required for WebSocket connection');
    }

    const response = await fetch(`${BASE_URL}auth/websocket-ticket/`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Accept-Language': getActiveLanguage(),
        Authorization: `Token ${token}`,
      },
      signal,
    });

    const payload = await response.json().catch(() => null);
    if (!response.ok || !payload?.url) {
      const error = new Error(payload?.error || payload?.detail || 'Could not create WebSocket ticket');
      error.status = response.status;
      error.code = payload?.code || payload?.error_code || payload?.error || null;

      const retryAfter = response.headers?.get?.('Retry-After') || null;
      error.retryAfter = retryAfter;
      error.retryAfterMs = parseRetryAfter(retryAfter);
      throw error;
    }

    return payload;
  },
};

export const parseRetryAfter = (value, now = Date.now()) => {
  if (value === null || value === undefined || value === '') return null;

  const seconds = Number(value);
  if (Number.isFinite(seconds) && seconds >= 0) {
    return Math.round(seconds * 1000);
  }

  const date = Date.parse(value);
  if (Number.isNaN(date)) return null;
  return Math.max(0, date - now);
};

export default websocketAPI;
